import { createIconElement, PAYMENT_STATUS } from '@/lib';
import IcWarning from '@/assets/icons/ic-warning-circle.svg';
import { useState } from 'react';
import { disputeBannerContent, isDisputeCardVisible, isDisputeWon } from '../income.logic';
import { DisputeCard } from './DisputeCard';
import { ProductPayment } from '../types/transactionTypes';

interface DisputeProps {
    paymentData: ProductPayment;
    paymentId: string;
}

export function DisputeWarning({ paymentData, paymentId }: DisputeProps) {
    const [isDisputeSubmitted, setIsDisputeSubmitted] = useState(false);
    const isDisputed = paymentData.status === PAYMENT_STATUS.DISPUTED;
    const isPaymentDisputeWon = isDisputeWon(paymentData);
    const BareWarningSvg = createIconElement(IcWarning, {
        className: !isPaymentDisputeWon ? 'text-negative-active' : 'text-seafoam-main',
    });

    const disputeId = paymentData.data.dispute_id;
    const disputeCardVisible = isDisputeCardVisible(paymentData, isDisputeSubmitted);

    return (
        <div className='flex w-full flex-col items-start gap-6 p-0 text-sm'>
            {(isDisputed || isPaymentDisputeWon) && (
                <div
                    className={
                        'text-dark bg-negative-soft w-full rounded-2xl border-0 p-5 ' +
                        (isPaymentDisputeWon ? 'bg-success-soft' : ' ')
                    }
                >
                    <div className='flex items-center'>
                        <div className='mr-3 flex size-5 items-center'>{BareWarningSvg}</div>
                        <div className='mr-3 flex grow'>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: disputeBannerContent(paymentData, isDisputeSubmitted),
                                }}
                            />
                        </div>
                        <a
                            href='https://help.stan.store/article/49-stripe'
                            className={
                                'text-light font-bold !no-underline ' +
                                (!isPaymentDisputeWon ? '!text-negative-active' : '!text-seafoam-main')
                            }
                        >
                            Learn More
                        </a>
                    </div>
                </div>
            )}

            {/* <Transition name='fade' mode='out-in'> */}
            {disputeCardVisible && (
                <div className='shadow-nucleus-elevation-low flex w-full flex-col items-start gap-8 rounded-2xl bg-white p-8'>
                    <div className='flex w-full flex-wrap items-start gap-8 p-0'>
                        <DisputeCard
                            disputeId={disputeId}
                            paymentId={paymentId}
                            onDisputeSubmitted={() => setIsDisputeSubmitted(true)}
                        />
                    </div>
                </div>
            )}
            {/* </Transition> */}
        </div>
    );
}
